<template>
  <router-link
    :to="to"
    :class="$style.link"
  >
    {{ text }}
  </router-link>
</template>

<script>
export default {
  name: 'BaseLink',
  props: {
    text: {
      type: String,
      required: true,
    },
    to: {
      type: [Object, String],
      required: true,
    },
  },
}
</script>

<style module lang="scss">
  @import "../../assets/scss/variables";
  .link {
    font-size: $font-size-body;
  }
</style>
